import { Dialog } from 'primereact/dialog';
import {
  FundForm,
  FundFormProps,
  FundFormStatusEvt,
} from '~/components/forms/fund_form';
import { Toast } from 'primereact/toast';
import { useAtom } from 'jotai/index';
import { toastAtom } from '~/atoms/toastAtom';
import { useHierarchyEndpoint } from '~/api/useHierarchyEndpoint';

export type PopupFundFormProps = FundFormProps & {
  onHide: (updatedId?: string) => void;
  visible: boolean;
};
export const FundFormDialog = ({
  onHide,
  visible,
  ...props
}: PopupFundFormProps) => {
  const [toastCurrent] = useAtom<Toast | null>(toastAtom);
  const { loadHierarchy } = useHierarchyEndpoint();
  const handleOnSubmitComplete = async (status?: FundFormStatusEvt) => {
    if (toastCurrent && status) {
      toastCurrent.show({
        severity: !status?.isError ? 'success' : 'error',
        summary: 'Form Submitted',
        detail: status?.message || 'Unknown status',
      });
    }
    await loadHierarchy();
    onHide(props.fundId);
  };

  return (
    <Dialog
      onHide={onHide}
      visible={visible}
      style={{ width: '50vw', height: 'auto' }}
      header={`${props.formMode === 'edit' ? 'Edit Fund:' : 'Add Fund'} ${props.initialValue?.name}`}
    >
      <div className="pb-2">
        <FundForm onSubmitComplete={handleOnSubmitComplete} {...props} />
      </div>
    </Dialog>
  );
};
